import React, { useState } from 'react';
import { Route, Redirect } from "react-router-dom";
import FirebaseService from '../services/firebase';

const GuardedRoute = ({ component: Component, auth, ...rest }) => {

    const [user, setUser] = useState({});

    FirebaseService.currentUser.subscribe(data => {
      if (user.uid != data.uid) {
        setUser(data);
      }
    });

    return (
        <Route {...rest} render={(props) => (
            user.isAnonymous
                ? <Redirect to='/login' />
                : <Component {...props} />
        )} />
    )

}

export default GuardedRoute;